module.exports = __webpack_public_path__ + "static/media/state-add.dd5c143b.svg";